import { render, staticRenderFns } from "./DarkPurpleHeader.vue?vue&type=template&id=17ef50f6"
import script from "./DarkPurpleHeader.vue?vue&type=script&lang=js"
export * from "./DarkPurpleHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports